var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"text-field-readonly-copy",attrs:{"label":_vm.label,"value":_vm.value,"readonly":"","hide-details":true,"append-icon":"mdi-content-copy"},on:{"click:append":function($event){return _vm.copyToClipboard()}}})}
var staticRenderFns = []

export { render, staticRenderFns }